const factory = (Model, GatewayApi, $rootScope, PubnubActions) => {
  class UnreadMessages extends Model {
    $url(clientId) {
      const epoch = Date.now();
      const viewerId = this.$data().viewerId;
      const viewerUserGroup = this.$data().viewerUserGroup;
      const eventType = 'feed.message.created';
      const params = `before=${epoch}&names=${eventType}&group=${viewerUserGroup}`;
      return `messages/${clientId}/${this.$resource}/${viewerId}?${params}`;
    }

    $init() {
      // Passing `data` to the constructor causes `$lastUpdated` to be set to a non-zero, which caused this conditional
      // not to be called. Updated this check to ensure we have an `unreadMessageCount`.
      if ((this.$lastUpdated === 0 || this.unreadMessageCount == null) && this.id !== null) {
        this.$fetch();

        const messageCreatedEvent = PubnubActions.messageCreated({ clientId: this.id });
        this.$subscribe(messageCreatedEvent, e => this.onMessageCreated(e));
      }
    }

    get count() {
      return this.unreadMessageCount;
    }

    set count(value) {
      this.unreadMessageCount = value;
    }

    clearCount() {
      this.count = 0;
    }

    incrementCount() {
      this.count += 1;
    }

    onMessageCreated(e) {
      if (!e.context) return;
      const authorId = e.context.eventSource.authorId;
      if (this.id === authorId) return;

      // if viewing the feed, the 'New Messages' indicator is all they need
      if (window.location.pathname === '/') return;

      this.incrementCount();
    }
  }

  Object.assign(UnreadMessages.prototype, {
    $apiService: GatewayApi,
    $resource: 'unread',
  });

  return UnreadMessages;
};

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.unreadMessages', moduleDeps)
  .factory('UnreadMessages', factory);
